module.exports = __webpack_public_path__ + "img/move16.bea1c5fb.jpg";